export const education = [
    {
        date: "June 15, 2024",
        category: "In Production",
        title: "Best Candidate App",
        description: "This is our first successfull project, the best Candidate Mobile App designed with flutter."
    },
] 